import React, { useState, useEffect } from "react";
import LayoutCenter from "../UserInterface/LayoutCenter";
import { CardContainer } from "../UserInterface/CardContainer";
import Pagination from "../Pagination/Pagination";
import UseWindowSize from "../UseWindowSize";
import { getImageUrl } from "src/utils/magnolia";

const ContentContainer = ({ data, subSlug, setOffset }) => {
  const list = data.results;
  const pageNumber = [];
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  const [state, setState] = useState({
    currentPage: 1,
    listPerPage: 12
  });

  useEffect(() => {
    setWinSize(width);
  }, [width]);

  useEffect(() => {
    setOffset((state.currentPage - 1));
  }, [state.currentPage]);

  const { currentPage, listPerPage } = state;
  const renderListPage = list?.map((i, index) => (
    <CardContainer
      key={index}
      img={getImageUrl(i.thumbnail)}
      title={i.title}
      date={i.pers_date}
      button="Baca"
      href={`/tentang-perusahaan/${subSlug}/${i.slug}`}
      slug={`/tentang-perusahaan/${subSlug}/${i.slug}`}
    />
  ));

  for (let i = 1; i <= Math.ceil(data.total / listPerPage); i++) {
    pageNumber.push(i);
  }

  return (
    <React.Fragment>
      <LayoutCenter widthLayout="1000px">
        <div className="pers-list-container">{renderListPage}</div>
      </LayoutCenter>
      <Pagination pageNumber={pageNumber} currentPage={currentPage} winSize={winSize} state={state} setState={setState} />
      <style jsx>{`
        .pers-list-container {
          width: 100%;
          display: grid;
          grid-column-gap: 20px;
          grid-row-gap: 50px;
          grid-template-columns: 1fr 1fr 1fr;
        }
        @media only screen and (max-width: 600px) {
          .pers-list-container {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </React.Fragment>
  )
}

export default ContentContainer;